export default __webpack_public_path__ + "static/media/MJN.4ef158cb.mp4";